import SwiperCarousel from "../components/swiper-carousel";

export default {
    init()
    {
        // initialize image carousel.
        $("[data-home-image-carousel]").each(function () {
            const $swiperContainer = $(this);

            if ($swiperContainer.length === 0) {
                return false;
            }

            // Find pagination element within this specific carousel
            const paginationEl = $swiperContainer.find('.swiper-pagination')[0];

            const params = {
                pagination: {
                    el: paginationEl,
                    clickable: true,
                    type: 'bullets',
                    dynamicBullets: false,
                    renderBullet: null, // Use default rendering
                },
                disableOnInteraction: false,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
            };

            let imageCarousel = new SwiperCarousel($swiperContainer, params);

            try {
                const carouselInstance = imageCarousel.init();

                if (carouselInstance && carouselInstance.on) {
                    carouselInstance.on('slideChange', function () {
                        if (this.realIndex === 3 && window.innerWidth > 768 && this.autoplay) {
                            this.autoplay.stop();
                        }
                    });
                }
            } catch (error) {
                console.error('Error initializing image carousel:', error);
            }
        });

        // initialize news carousel.
        $(".help-advice-carousel").each(function () {
            const $carouselContainer = $(this);
            const buttons = {};
            const swiper = $('.swiper-container', $carouselContainer);

            if (swiper.length === 0) {
                return false;
            }

            buttons.left = $(".swiper-button-prev", $carouselContainer);
            buttons.right = $(".swiper-button-next", $carouselContainer);

            const params = {
                navigation: {
                    nextEl: buttons.right,
                    prevEl: buttons.left,
                },
            };

            if ($($carouselContainer).data('autoplay')) {
                params.autoplay = {
                    delay: 6500,
                }
            }

            let carousel = new SwiperCarousel(swiper, params);

            try {
                const carouselInstance = carousel.init();

                if (carouselInstance && carouselInstance.on) {
                    carouselInstance.on('slideChange', function () {
                        if (this.realIndex === 5 && window.innerWidth > 768 && this.autoplay) {
                            this.autoplay.stop();
                        }
                    });
                }
            } catch (error) {
                console.error('Error initializing news carousel:', error);
            }
        });

        // initialize news carousel.
        $(".news-carousel").each(function () {
            const $carouselContainer = $(this);
            const buttons = {};
            const swiper = $('.swiper-container', $carouselContainer);

            if (swiper.length === 0) {
                return false;
            }

            buttons.left = $(".swiper-button-prev", $carouselContainer);
            buttons.right = $(".swiper-button-next", $carouselContainer);

            const params = {
                navigation: {
                    nextEl: buttons.right,
                    prevEl: buttons.left,
                },
            };

            if ($($carouselContainer).data('autoplay')) {
                params.autoplay = {
                    delay: 6500,
                }
            }

            let carousel = new SwiperCarousel(swiper, params);

            try {
                const carouselInstance = carousel.init();

                if (carouselInstance && carouselInstance.on) {
                    carouselInstance.on('slideChange', function () {
                        if (this.realIndex === 3 && window.innerWidth > 768 && this.autoplay) {
                            this.autoplay.stop();
                        }
                    });
                }
            } catch (error) {
                console.error('Error initializing news carousel:', error);
            }
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};






// WEBPACK FOOTER //
// ./scripts/routes/templateHome.js